import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useTypedParams } from '@sorare/core/src/lib/routing';

import { InventoryBoxesTypePage } from '@sorare/gameplay/src/pages/inventory/InventoryBoxesTypePage';

import { PageParams } from './__generated__/routeParams';

const NBAInventoryBoxesTypePage = () => {
  const { type } = useTypedParams<PageParams>();
  return <InventoryBoxesTypePage sport={Sport.NBA} type={type} />;
};

export default NBAInventoryBoxesTypePage;
